import React, {useState} from "react";
import {observer} from "mobx-react";
import {useStores} from "../../Hooks";
import GeneralDialog from "./GeneralDialog";

const SetSitePrepNameModal = observer(() => {
    const {modalStore, generalStore, projectStore} = useStores();

    const [sitePrepName, setSitePrepName] = useState(modalStore.modalData.sitePrepData?.ProcedureName || "");

    const isTemplate = modalStore.modalData.isTemplate;
    const isAddNew = !!modalStore.modalData.isAddNew;
    const trimmedName = sitePrepName && sitePrepName.trim();

    const renderBody = () => {
        return (
            <input
                className='site-prep-name-input'
                placeholder={generalStore.translate('addName')}
                value={sitePrepName}
                onChange={e => setSitePrepName(e.target.value)}
            />
        )
    }

    const checkSameName = () => isTemplate
        ? projectStore.checkSitePrepTemplateSameName(sitePrepName, modalStore.modalData.sitePrepData?.TemplateIdentifier)
        : projectStore.checkProcedureSameName(sitePrepName);

    const addNameAndGoToNext = () => {
        if (isTemplate) {
            modalStore.isSelectSitePrepFusionFilesModalOpen = true;
        } else {
            modalStore.isSelectSitePrepTemplateModalOpen = true;
        }
        modalStore.isSetSitePrepNameModalOpen = false;
    }

    const onConfirm = async () => {
        if (checkSameName()) {
            return modalStore.showErrorMessage(generalStore.translate('itemWithSameNameAlreadyExistsInProject'));
        }
        modalStore.modalData.sitePrepData.ProcedureName = sitePrepName;
        if (isAddNew) {
            addNameAndGoToNext();
        } else {
            await modalStore.modalData.updateSitePrep();
            modalStore.isSetSitePrepNameModalOpen = false;
        }
    }

    const onEnter = () => setSitePrepName(modalStore.modalData.sitePrepData?.ProcedureName || "");

    return (
        <GeneralDialog
            openControl='isSetSitePrepNameModalOpen'
            className={'procedure-option-dialog site-prep-options'}
            onEnter={onEnter}
            title={generalStore.translate(isTemplate ? 'nameTemplate' : 'nameSite')}
            body={renderBody()}
            noCancel={isAddNew}
            isConfirmDisabled={!trimmedName}
            confirmText={generalStore.translate(isAddNew ? 'next' : 'rename')}
            onConfirm={onConfirm}
            extraClose
        />
    );
});

export default SetSitePrepNameModal;